/** @jsx jsx */
import { jsx } from "@emotion/react";

import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";

const Wysiwyg = ({ html, style }) => <FroalaEditorView model={html} css={style} />;

export default Wysiwyg;
